import { useEffect, useState } from 'react'
import { apiService } from '../services/api.service'

export const useThumbnail = (documentId: number | null | undefined) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!documentId) {
      setBlobUrl(null)
      setLoading(false)
      return
    }

    let blobUrlToCleanup: string | null = null
    let mounted = true

    const loadThumbnail = async () => {
      try {
        setLoading(true)
        setError(false)

        const response = await apiService.get(`documents/${documentId}/thumb/`, {
          responseType: 'blob',
        })

        if (!mounted) return

        const blob = response.data as Blob
        const url = URL.createObjectURL(blob)
        blobUrlToCleanup = url
        setBlobUrl(url)
        setLoading(false)
      } catch (err) {
        if (!mounted) return
        setError(true)
        setLoading(false)
        setBlobUrl(null)
      }
    }

    loadThumbnail()

    return () => {
      mounted = false
      if (blobUrlToCleanup) {
        URL.revokeObjectURL(blobUrlToCleanup)
      }
    }
  }, [documentId])

  return { blobUrl, loading, error }
}
